import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { ConfigService, XpressCenterService, AppDataService } from 'app/services';
import { MenuPermissionActionEnum } from 'app/models';
import { Utils } from 'app/utils';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'home-driver-centers',
    templateUrl: './home-driver-centers.component.html',
    styleUrls: ['./home-driver-centers.component.scss'],
    providers: [MessageService]
})
export class HomeDriverCentersComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }, { label: 'Xpress Locations' }];

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    constructor(
        public configService: ConfigService,
        private xpressCenterService: XpressCenterService,
        private messageService: MessageService,
        public appData: AppDataService
    ) {
        this.handleInfoPopupHide = this.handleInfoPopupHide.bind(this);
        this.handleCreatePopupHide = this.handleCreatePopupHide.bind(this);
    }

    ngOnInit(): void {
    }

    public cols: any[] = [
        { field: 'Id', header: 'ID', width: '80px' },
        { field: 'Name', header: 'Name', width: '350px' },
        { field: 'City', header: 'City', width: '250px' },
        { field: 'ContractEndedAtStr', header: 'Contract End', width: '200px' },
        { field: 'MonthlyRentStr', header: 'Monthly Rent', width: '200px' },
        { field: 'ExpensesStr', header: 'Expenses', width: '200px' },
        { field: 'EmployeesCount', header: 'Employees', width: '200px' }
    ];
    public defaultCols = this.cols.map(x => x);

    public tableName: string = 'Xpress Centers';
    public xpressCenters: Array<any> = [];
    public xpressCenter: any;
    public selectedCenters: any;
    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
        city: string;
    } = { searchName: '', city: '' };
    private searchTimer: number = 0;


    public loading: boolean = true;
    public visibleUserFilter: boolean = false;

    public showInfoPopup: boolean = false;
    public showEditFields: boolean = false;
    public showCreatePopup: boolean = false;
    public showRemoveCenter: boolean = false;

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public getXpressCenters(skip: number) {
        this.loading = true;

        const dto = {
            SearchName: this.filter.searchName,
            City: this.filter.city,
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };

        this.xpressCenterService.getXpressCenters(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.xpressCenters = data.XpressCenters.map((x: any) => {
                    x.ContractEndedAtStr = Utils.utcToLocaleDateString(x.ContractEndedAt);
                    x.ContractStartedAtStr = Utils.utcToLocaleDateString(x.ContractStartedAt);
                    x.MonthlyRentStr = String.fromCharCode(8369) + x.MonthlyRent;
                    x.ExpensesStr = String.fromCharCode(8369) + x.Expenses;
                    x.CusaFeeStr = String.fromCharCode(8369) + x.CusaFee;
                    return x;
                });

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });

    }

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        this.sortField = event.sortField ? event.sortField : '';

        if (event.sortOrder) {
            this.sortOrder = event.sortOrder;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getXpressCenters(skip);
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getXpressCenters(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public openCentersFilter() {
        this.visibleUserFilter = !this.visibleUserFilter;
    }

    public handleInfoPopupHide(): void {
        this.showInfoPopup = false;
        this.xpressCenter = undefined;
        this.getXpressCenters(0);
    }

    public handleShowCreatepopup() {
        if (this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Create) ||
            this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Update)) {
            this.showCreatePopup = true;
        } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Access denied' });
        }
    }

    public handleCreatePopupHide(): void {
        this.showCreatePopup = false;
        this.getXpressCenters(0);
    }

    public handleInfoPopupShow(xpressCenter: any) {
        this.xpressCenter = xpressCenter;
        this.showInfoPopup = true;
    }

    public handleRemoveCenterPopup(center: any) {
        this.xpressCenter = center;
        this.showRemoveCenter = true;
    }

    public removeXpressCenter(center: any) {
        const dto = {
            Id: center.Id,
        };
        this.loading = true;

        this.xpressCenterService.removeXpressCenter(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.showRemoveCenter = false;
                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Xpress Center has been removed' });
                this.getXpressCenters(0);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
}
